import apiService from '../api/api.service';
import {ProductFeed, RemoteProductFeed} from './productFeed.types';
import toClientProductFeed from './productFeed.dataConverter';
import apiV2Service from '../api/api-v2.service';

const basePath = `Feeds`;

async function getFeeds(): Promise<ProductFeed[]> {
  const {data} = await apiService.executeGetRequest<Array<Array<RemoteProductFeed>>>(
    `${basePath}/GetAll`,
  );
  const [feedItemsResponse] = data;

  return feedItemsResponse.map(toClientProductFeed);
}

async function getByProductType(productType: number): Promise<ProductFeed[]> {
  const {data} = await apiService.executeGetRequest<Array<Array<RemoteProductFeed>>>(
    `${basePath}/GetByProductType`,
    {productType: productType},
  );
  const [feedItemsResponse] = data;

  return feedItemsResponse.map(toClientProductFeed);
}

async function getStrategyOptionalFeeds(strategy: number): Promise<ProductFeed[]> {
  const {data} = await apiService.executeGetRequest<Array<Array<RemoteProductFeed>>>(
    `${basePath}/GetStrategyOptionalFeeds`,
    {strategy},
  );
  const [feedItemsResponse] = data;

  return feedItemsResponse.map(toClientProductFeed);
}

async function searchFeeds(searchTerm: string): Promise<{
  productFeeds: RemoteProductFeed[];
  filtersExplanation: string;
}> {
  const {data} = await apiV2Service.executeGetRequest<{
    productFeeds: RemoteProductFeed[];
    filtersExplanation: string;
  }>(`${basePath}/SearchProductFeeds`, {prompt: searchTerm});

  return data;
}

export default {
  getFeeds,
  getByProductType,
  getStrategyOptionalFeeds,
  searchFeeds,
};
